import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./Header.sass";
import PageContext from "./../store/page/page-context";
import { useContext, useEffect, useMemo, useRef, useState } from "react";

import langZh from "../../assets/images/header/lang-zh.svg";
import langEn from "../../assets/images/header/lang-en.svg";
import langJp from "../../assets/images/header/lang-jp.svg";
import langCn from "../../assets/images/header/lang-cn.svg";

const langList = {
  en: { text: "English", img: langEn },
  zh: { text: "繁中", img: langZh },
  jp: { text: "日本語", img: langJp },
  cn: { text: "簡中", img: langCn },
};

export default function Header() {
  const { i18n } = useTranslation();
  const { data } = useContext(PageContext);

  const langImg = langList[i18n.language];
  const langOptionList = useMemo(() => {
    return Object.keys(langList).filter((key) => key !== i18n.language);
  }, [i18n.language]);

  const [openLang, setOpenLang] = useState(false);
  const langRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (langRef.current && !langRef.current.contains(event.target)) {
        setOpenLang(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const ToggleLangHandler = () => {
    setOpenLang(!openLang);
  };

  const changeLangHandler = (item) => {
    i18n.changeLanguage(item);
    setOpenLang(false);
  };

  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY >= window.innerWidth * 0.05) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      {data.headerShow ? (
        <header className={`header ${isScrolled ? "-scroll" : ""}`}>
          <div className="header-logo">
            <img src={data.logo} alt="" />
          </div>
          {data.title ? (
            <div className="header-title">
              <div>{data.title}</div>
            </div>
          ) : (
            ""
          )}
          <div className="header-action">
            <div className="header-lang">
              <div className="lang" ref={langRef}>
                <button
                  className="lang-val"
                  style={{ backgroundImage: `url(${langImg.img})` }}
                  type="button"
                  onClick={() => {
                    ToggleLangHandler();
                  }}
                ></button>
                <div className={`lang-options ${openLang ? "active" : ""}`}>
                  {langOptionList.map((item) => {
                    return (
                      <button
                        onClick={() => {
                          changeLangHandler(item);
                        }}
                        type="button"
                        key={item}
                      >
                        {langList[item].text}
                      </button>
                    );
                  })}
                </div>
              </div>
            </div>
            <Link className="header-home" to="/"></Link>
          </div>
          {/* <ul>
            <li>
              <Link to="/">{t("homepage.title")}</Link>
            </li>
            <li>
              <Link to="/about">{t("about.title")}</Link>
            </li>
            <li>
              <Link to="/canvas">{t("canvas.title")}</Link>
            </li>
            <li>
              <Link to="/loginAnimation">{t("loginAnimation.title")}</Link>
            </li>
            <li>
              <Link to="/initialExplanation">{t("initialExplanation.title")}</Link>
            </li>
            <li>
              <Link to="/bearExplanation">{t("bearExplanation.title")}</Link>
            </li>
            <li>
              <Link to="/bearSelection">{t("bearSelection.title")}</Link>
            </li>
            <li>
              <Link to="/myBear">{t("myBear.title")}</Link>
            </li>
            <li>
              <Link to="/course">{t("course.title")}</Link>
            </li>
            <li>
              <Link to="/lottery">{t("lottery.title")}</Link>
            </li>
            <li>
              <Link to="/start">start</Link>
            </li>
          </ul> */}
        </header>
      ) : (
        ""
      )}
    </>
  );
}
